import { Component } from '@angular/core';
import { ExcelDumpDashboardService } from './excel-dump-dashboard.service';
import { LogmanagementService } from '../logmanagement/logmanagement.service';
import { environment } from 'src/environments/environment.prod';
import { ToastMessageService } from 'src/app/toastr.service';

@Component({
  selector: 'app-excel-dump-dashboard',
  templateUrl: './excel-dump-dashboard.component.html',
  styleUrl: './excel-dump-dashboard.component.scss'
})
export class ExcelDumpDashboardComponent {
  selectedTab: string = 'product';
  keys: string[] = [];
  formattedKeys: { label: string; value: string }[] = []; // For dropdown
  selectedKeys: string[] = [];
  email: any;
  selectedOptions: { [key: string]: string[] } = {};
  optionsMap: { [key: string]: string[] } = {};
  dialogVisible: boolean = false;
  excelName: string = '';
  selectedROA: string = 'ALL';
  ROADropdownOptions: any[] = [];
  statusOptions = [
    { label: 'Live', value: 'live' },
    { label: 'QA', value: 'not_live' }
  ];
  selectedStatus: string = 'live';
  isLoadingDump: boolean = false;
  dumpModeOptions = [
    { label: 'Field-wise Dump', value: 'field' },
    { label: 'Row-wise Dump', value: 'row' }
  ];
  dumpMode: string = '';
  dumpType: string = '';

  constructor(private excelService: ExcelDumpDashboardService, private toastService: ToastMessageService, private logmanagementservice: LogmanagementService,) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.loadKeys();
    this.getRoa();
  }

  switchTab(tab: string): void {
    this.selectedTab = tab;
    if (tab === 'product') {
      this.loadKeys();
    }
  }

  openDialog(dumpType: string = '') {
    this.dumpType = dumpType;
    this.dialogVisible = true;
  }

  loadKeys(): void {
    if (!this.email) return;

    this.excelService.getAllKeys(this.email).subscribe({
      next: (res) => {
        this.keys = res?.keys || [];
        this.formattedKeys = this.keys.map(key => ({ label: key, value: key }));
        this.optionsMap = res?.options || {};
      },
      error: (err) => {
        console.error('Error fetching keys:', err);
        this.keys = [];
        this.formattedKeys = [];
      }
    });
  }

  getRoa() {
    this.logmanagementservice.getUniqueRoa().subscribe(
      (response) => {
        this.ROADropdownOptions = response["data"].map((roa: string) => ({
          label: roa,
          value: roa
        }));
        this.selectedROA = "ALL"; // Default selected value
      },
      (error) => {
        console.error('Error fetching ROA data', error);
      }
    );
  }

  saveDump(): void {
    if (!this.email || !this.excelName) {
      console.warn("Missing data");
      return;
    }

    if (this.selectedTab === 'product' && !this.selectedKeys.length) {
      console.warn("Missing data");
      return;
    }

    this.isLoadingDump = true;

    const payload = {
      user_email: this.email,
      dump_source: this.selectedTab,
      fields: this.selectedKeys,
      selected_roa: this.selectedTab === 'costing' ? "" : this.selectedROA,
      selected_status: this.selectedTab === 'costing' ? "" : this.selectedStatus,
      excel_name: this.excelName,
      dump_mode: this.dumpMode,
      dump_type: this.dumpType || ""
    };
    this.excelService.getExcelDump(payload).subscribe({
      next: (res) => {
        console.log('Dump created successfully:', res);
        if (res["file"]) {
          const fileUrl = res["file"];  // e.g. 'uploads/excelDump/somefile.xlsx'
          const fullUrl = `${environment.ip}pm_backend/${fileUrl}`;
          window.open(fullUrl, '_blank');  // Open/download the file
        }

        this.dialogVisible = false;
        this.excelName = '';
      },
      error: (err) => {
        console.error('Error creating dump:', err);
        this.isLoadingDump = false;
        this.toastService.error("Failed to create dump. Please try again.");
      },
      complete: () => {
        this.isLoadingDump = false;
      }
    });
  }

}
